import { Nillable } from "../base/@types";
import { ApiModelName, getApiModelDef } from "../constants/ApiModels.enum";

export const getModelNameFromApiModelName = (appModel?: Nillable<ApiModelName> | '') => {
  return getApiModelDef(appModel)?.name;
}